export const LINK_ENTRY_ID = 'linkEntryId';
export const LINK_PARENT_ENTRY_ID = 'linkParentEntryId';
export const LINK_ENTRY_NAME = 'linkEntryName';
